/***
 * 创建人：李珊
 * 时间：2020-03-09
 * 描述：关系配置：查看关系详情操作
 * 更新说明:
 */
 import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
 import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
 import { KmsService } from 'src/app/areas/kms/kms.service';
 import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
 @Component({
  selector: 'app-relation-view',
  templateUrl: './relation-view.component.html',
  styleUrls: ['./relation-view.component.css']
})
export class RelationViewComponent implements OnInit {
   
   @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
   @Input() param:any;
   @Output() callback = new EventEmitter(); //抛出事件
   //数据绑定对象
   model: any = {
    // 起始实体数据信息
    sourceProperties: {
        nodeName: '',
        conceptId: '',
    },
    // 指向实体数据信息
    targetProperties: {
        nodeName: '',
        conceptId: '',
    },
    // 关联关系数据
    properties: {
      startDate: "", // 起始时间
      startDateNote: "", // 起始时间备注
      endDate: "", // 结束时间
      endDateNote: "", // 结束时间备注
      parentId: "", // 关系父级ID
      relationshipId: "", // 关系ID
      relationshipName: "", // 关系名称
      reverseRelationName: "", // 反向关系名称
      uuid: "", // 当前数据ID
      materialId:'', // 关系来源
      description: "", // 关联备注
      sourceMaterial:'',
      pageNum:null,
      relPageNum:null,
      dataSource: "" 
    },
    sourceUUID: '',  // 起始实体ID
    targetUUID: '',  // 指向实体ID
  }; 
   constructor(
     private box: SwMassageBoxService,  //消息提示框
     private kmsService: KmsService,   //请求服务
   ) { 
 
   }
 
   ngOnInit() {
     this.clickLoca(this.param);
   }
   
   clickLoca(selectedData: any) {
     // 查询关系信息
     let params = {
      startNodeId: selectedData.startNodeId,
      uuid: selectedData.uuid,
     }
     this.kmsService.getRelationshipById(params).subscribe(
      result => {
          if (result.code == 200) {
            this.model = result.data;
          } else {
            this.box.waring(result.msg);
          }
      }
    )
   }
 }
 
 
 
